import type { ReactNode } from 'react';

import { cn } from '../lib/cn';

export interface EyebrowProps {
  children: ReactNode;
  className?: string;
}

/**
 * The small label above a section heading: the identity's overline — Plex Mono,
 * uppercase and tracked in Latin, plain and proportional in Arabic. It names
 * where you are; it is not content, which is why it rides on `.hs-overline`
 * rather than on the body type scale.
 *
 * The marker is a 1u square in Ink: the identity's dot is a square, never a
 * circle, and it is not Amber — the carry is spent once per composition, on the
 * thing that matters.
 */
export function Eyebrow({ children, className }: EyebrowProps) {
  return (
    <p className={cn('hs-overline flex items-center gap-2.5', className)}>
      <span className="size-1.5 shrink-0 rounded-[1.5px] bg-text" aria-hidden="true" />
      {children}
    </p>
  );
}
